module.exports = __webpack_public_path__ + "media/images/sprites/dot-a34d8a967f201475909c97d61449531f.svg";